"use client";
import { j as t } from "./index.es44.js";
import { useState as N, useEffect as h } from "react";
import { composeClassNames as a } from "./index.es126.js";
import S from "./index.es127.js";
const $ = ({
  type: b = "button",
  children: m,
  styleType: l = "primary",
  isSmall: e = !1,
  isFullWidth: c,
  isLoading: s = !1,
  loadingDelayMs: i = 0,
  onClick: d,
  isDisabled: f = !1,
  iconName: r,
  isIconOnly: u,
  iconSize: p,
  ...y
}) => {
  const [n, o] = N(s), x = s && !n;
  h(() => {
    if (i === 0) {
      o(s);
      return;
    }
    if (s) {
      const j = setTimeout(() => {
        o(!0);
      }, i);
      return () => clearTimeout(j);
    } else
      o(!1);
  }, [s, i]);
  const g = p || "small";
  return /* @__PURE__ */ t.jsxs(
    "button",
    {
      ...y,
      className: a(
        "bl-button",
        e && "bl-button--small",
        !e && "bl-button--medium",
        u && "bl-button--icon-only",
        c && "bl-button--fluid",
        n && "bl-button--loading",
        x && "bl-button--pending-loading",
        l && `bl-button--${l}`
      ),
      onClick: d,
      type: b,
      disabled: f || s,
      children: [
        /* @__PURE__ */ t.jsx(
          "span",
          {
            className: a(
              "bl-button__consumer-content",
              u && "bl-sr-only"
            ),
            children: m
          }
        ),
        r && /* @__PURE__ */ t.jsx(
          "i",
          {
            "aria-hidden": !0,
            className: a(
              `bl-icon--${r}`,
              `bl-icon--${g}`
            )
          }
        ),
        n && /* @__PURE__ */ t.jsx(
          S,
          {
            isDark: l === "secondary" || l === "tertiary",
            isSmall: e
          }
        )
      ]
    }
  );
};
export {
  $ as default
};
//# sourceMappingURL=index.es45.js.map
